module.exports = __webpack_public_path__ + "static/img/Sio.382e107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Sio.jpg
// module id = 2UID
// module chunks = 1